/* eslint-disable jsx-a11y/anchor-is-valid */

import Spinner from "helpers/Spinner";
import { nanoid } from "nanoid";
import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { import_current_tab, import_set_data, import_casa, import_setRecursos } from './store'
import { GET, POST_IMPORT } from 'helpers/request';
import {Link} from "react-router-dom"
import LanguageHelper from 'helpers/language_helper'

class ImportFileStep1 extends Component {
  state = {
    nameCurrentFile: 'Buscar',
    filePreUploaded: false,
    startUpload: false,
    percentageUpload: 0,
    selTypeInformation: -1,
    estandar: "",
    listSubtematica: [],
    listIndicators: [],
    fromDataImport: {},
    selThematic:-1,
    selSubthematic:-1
  }
  selTypeInformation = null
  constructor(props) {
    super(props)

    this.selTypeInformation = createRef()
  
  }
  componentDidMount() {
    // this.props.COptionTypeInformation.bind(this)

  
    if (+this.props.importData.typeInformation > 0)
      this.selTypeInformation.current.value = this.props.importData.typeInformation
    this.setState({
      selTypeInformation: this.selTypeInformation.current.value
    })
    // this.selTypeInformation.current.value = 7
  }
  onChange = (evt) => {
    
    console.log(evt.target)

    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;

    if (evt.target.name.toString() === 'file-doc') {
      
      //change name curretn file
      let tn = 'Buscar'
      if (evt.target.files[0]) {
        tn = evt.target.files[0].name
      }
      this.setState({
        nameCurrentFile: tn
      })
    }

    if (evt.target.name === 'selTypeInformation') {
      var index = evt.target.selectedIndex;
      var optionElement = evt.target.childNodes[index]
      var estandar = optionElement.getAttribute('estandar');
      this.props.import_set_data({
        typeInformation: evt.target.value,
        estandar: estandar
      })
      this.setState({
        estandar: estandar
      });
      // this.getResourceByTypeIOfformation(evt.target.value)
    }

    if (evt.target.name === 'selThematic') {
      Spinner.show()
      if (document.getElementById('selSubthematic') != null) {
        document.getElementById('selSubthematic').value = -1;
      }

      this.setState({
      selSubthematic: -1
      })
      const fetcher = async () => {
        await GET(`indicators/subthematicsByThematic/`+evt.target.value).then(res => {
            console.log(res)
            this.setState({
              listSubtematica: res.datos,
              listIndicators: []
          })
           
      
          Spinner.hide()
        })
        
      };
      fetcher();
     

      // this.getResourceByTypeIOfformation(evt.target.value)
    }

    if (evt.target.name === 'selSubthematic') {
      Spinner.show()
      if (document.getElementById('selTypeInformation') != null) {
        document.getElementById('selTypeInformation').value = -1;
      }
      this.setState({
        selTypeInformation: -1
        })
      
     

      const fetcher = async () => {
        await GET(`indicators/getIndicatorsBySubthematic/`+evt.target.value).then(res => {
            console.log(res)
            this.setState({
              listIndicators: res.datos
          })
           
          Spinner.hide()
           
        })
        
      };
      fetcher();
     

      // this.getResourceByTypeIOfformation(evt.target.value)
    }


    if (evt.target.name === 'file-doc') {
      this.setState({
        filePreUploaded: true
      })
    }
    this.setState({
      [evt.target.name]: value,
    });
  }

  COptionThematic = (currentOption = -1) =>  (   
    this.state.listSubtematica.map((item, index) => <option key={index} value={ item.value }>{ item.name}</option>)
  
    )

  COptionIndicators = (currentOption = -1) =>  (   
    this.state.listIndicators.map((item, index) => <option key={index} value={ item.value }>{ item.name}</option>)
  )

  gotToStep2 = () => {
    return this.state.filePreUploaded && this.state.selTypeInformation !== -1
  }

  textprueba = () => {
    console.log(this.props)
    console.log(this.state)
    return this.props.currentTab;
  }

  descargarTemplate = async (e) => {
    e.preventDefault();
    
    
    try {
      await GET(`indicators/getTemplate`);
     
      
    } catch (error) {
      console.log("error", error)
    }
  };

   onSubmit_Step1 = async (event) => {
    event.preventDefault(0)
    
   Spinner.show()
    // let sendData = this.state
    this.setState({
      startUpload: true
    })
    let sendData = new FormData(document.getElementById('frmImportStep1'));
    sendData.append('tempid', 'IDT' + nanoid(10).toString());

    await POST_IMPORT(sendData,`indicators/importIndicators?step=1`).then(res => {
      Spinner.hide()
      this.setState({
        startUpload: false,
        percentageUpload: 0
      })
      if (res.success) {


        this.props.import_set_data({
          idFile: res.data.id,
          idFileName: res.data.namefile,
          fileName: res.data.file,
          typeInformationName: res.data.variable.ind_txt_name,
          typeFile: res.data.typeFile,
          table: res.data.table,
          successTemplate: res.successTemplate,
          errorCodCountries: res.data.errorCodCountries,
          countries: res.data.table.countries,
          countriesVal: res.data.table.countriesCOnsult,
          catOne: res.data.table.catOne,
          catTwo: res.data.table.catTwo,
          catThree: res.data.table.catThree,
          catFour: res.data.table.catFour,
          catFive: res.data.table.catFive,
          catFileOne: res.data.table.catFileOne,
          catFileTwo: res.data.table.catFileTwo,
          catFileThree: res.data.table.catFileThree,
          catFileFour: res.data.table.catFileFour,
          catFileFive: res.data.table.catFileFive,
          subcatOne: res.data.table.subCatOne,
          subcatTwo: res.data.table.subCatTwo,
          subcatThree: res.data.table.subCatThree,
          subcatFour: res.data.table.subCatFour,
          subcatFive: res.data.table.subCatFive,
          subcatFileOne: res.data.table.subCatFileOne,
          subcatFileTwo: res.data.table.subCatFileTwo,
          subcatFileThree: res.data.table.subCatFileThree,
          subcatFileFour: res.data.table.subCatFileFour,
          subcatFileFive: res.data.table.subCatFileFive

        })

        let countriesConsulta = this.props.importData.countriesVal[0];
        const listItems = countriesConsulta.map((number) =>
          number.cou_int_id
        );
        let countriesArchivo = this.props.importData.countries;
        const foundCountries = countriesArchivo.every(r => listItems.includes(r))

        if (!foundCountries) {
          this.props.import_set_data({
            errorCodCountries: true
          })
        }
        else {
          this.props.import_set_data({
            errorCodCountries: false
          })
        }



        let catOne = this.props.importData.catOne;
        let catTwo = this.props.importData.catTwo;
        let catThree = this.props.importData.catThree;
        let catFour = this.props.importData.catFour;
        let catFive = this.props.importData.catFive;

        const listItemsCatOne = catOne[0].map((number) =>
          number.cat_int_id_1
        );

        const listItemsCatTwo = catTwo[0].map((number) =>
          number.cat_int_id_2
        );

        const listItemsCatThree = catThree[0].map((number) =>
          number.cat_int_id_3
        );

        const listItemsCatFour = catFour[0].map((number) =>
          number.cat_int_id_4
        );

        const listItemsCatFive = catFive[0].map((number) =>
          number.cat_int_id_5
        );


        let categFileOne = this.props.importData.catFileOne;
        let categFileTwo = this.props.importData.catFileTwo;
        let categFileThree = this.props.importData.catFileThree;
        let categFileFour = this.props.importData.catFileFour;
        let categFileFive = this.props.importData.catFileFive;


        if ((listItemsCatOne[0] == null) && categFileOne.length > 1) {
          this.props.import_set_data({
            errorNotCatOne: true
          })
        }
        else {
          if (categFileOne.length < 1) {
            this.props.import_set_data({
              errorNotCatOne: false
            })
          }
          const foundCatOne = categFileOne.every(r => listItemsCatOne.includes(r))

          if (!foundCatOne) {
            this.props.import_set_data({
              errorCatOne: true
            })
          }
          else {
            this.props.import_set_data({
              errorCatOne: false
            })
          }

        }


        if ((listItemsCatTwo[0] == null) && categFileTwo.length > 1) {
          this.props.import_set_data({
            errorNotCatTwo: true
          })
        }
        else {

          if (categFileTwo.length < 1) {

            this.props.import_set_data({
              errorNotCatTwo: false
            })
          }
          const foundCatTwo = categFileTwo.every(r => listItemsCatTwo.includes(r))
          if (!foundCatTwo) {
            this.props.import_set_data({
              errorCatTwo: true
            })
          }
          else {
            this.props.import_set_data({
              errorCatTwo: false
            })
          }

        }


        if ((listItemsCatThree[0] == null) && categFileThree.length > 1) {
          this.props.import_set_data({
            errorNotCatThree: true
          })
        }
        else {
          if (categFileThree.length < 1) {

            this.props.import_set_data({
              errorNotCatThree: false
            })
          }
          const foundCatTwo = categFileThree.every(r => listItemsCatThree.includes(r))

          if (!foundCatTwo) {
            this.props.import_set_data({
              errorCatThree: true
            })
          }
          else {
            this.props.import_set_data({
              errorCatThree: false
            })
          }

        }


        if ((listItemsCatFour[0] == null) && categFileFour.length > 1) {
          this.props.import_set_data({
            errorNotCatFour: true
          })
        }
        else {
          if (categFileFour.length < 1) {

            this.props.import_set_data({
              errorNotCatFour: false
            })
          }
          const foundCatTwo = categFileFour.every(r => listItemsCatFour.includes(r))

          if (!foundCatTwo) {
            this.props.import_set_data({
              errorCatFour: true
            })
          }
          else {
            this.props.import_set_data({
              errorCatFour: false
            })
          }

        }



        if ((listItemsCatFive[0] == null) && categFileFive.length > 1) {
          this.props.import_set_data({
            errorNotCatFive: true
          })
        }
        else {
          if (categFileFive.length < 1) {

            this.props.import_set_data({
              errorNotCatFive: false
            })
          }
          const foundCatFive = categFileFive.every(r => listItemsCatFive.includes(r))

          if (!foundCatFive) {
            this.props.import_set_data({
              errorCatFive: true
            })
          }
          else {
            this.props.import_set_data({
              errorCatFive: false
            })
          }

        }

        let subcatOne = this.props.importData.subcatOne;
        let subcatTwo = this.props.importData.subcatTwo;
        let subcatThree = this.props.importData.subcatThree;
        let subcatFour = this.props.importData.subcatFour;
        let subcatFive = this.props.importData.subcatFive;

        const listItemsSubCatOne = subcatOne[0].map((number) =>
          number.sct_int_id
        );

        const listItemsSubCatTwo = subcatTwo[0].map((number) =>
          number.sct_int_id
        );

        const listItemsSubCatThree = subcatThree[0].map((number) =>
          number.sct_int_id
        );

        const listItemsSubCatFour = subcatFour[0].map((number) =>
          number.sct_int_id
        );

        const listItemsSubCatFive = subcatFive[0].map((number) =>
          number.sct_int_id
        );

        let subcategFileOne = this.props.importData.subcatFileOne;
        let subcategFileTwo = this.props.importData.subcatFileTwo;
        let subcategFileThree = this.props.importData.subcatFileThree;
        let subcategFileFour = this.props.importData.subcatFileFour;
        let subcategFileFive = this.props.importData.subcatFileFive;
        if (categFileOne.length<1 && (listItemsSubCatOne[0] != null) && subcategFileOne.length > 1) {
          this.props.import_set_data({
            errorNotCatSubCatOne: true
          })
        }
        else {
          if ((listItemsSubCatOne[0] == null) && subcategFileOne.length > 1) {
            this.props.import_set_data({
              errorNotSubCatOne: true
            })
          }
          else {
            if (subcategFileOne.length < 1) {
              this.props.import_set_data({
                errorNotSubCatOne: false
              })
            }
            const foundCatOne = subcategFileOne.every(r => listItemsSubCatOne.includes(r))

            if (!foundCatOne) {
              this.props.import_set_data({
                errorSubCatOne: true
              })
            }
            else {
              this.props.import_set_data({
                errorSubCatOne: false
              })
            }

          }
        }


        if (categFileTwo.length<1 && (listItemsSubCatTwo[0] != null) && subcategFileTwo.length > 1) {
          this.props.import_set_data({
            errorNotCatSubCatTwo: true
          })
        }
        else {
          if ((listItemsSubCatTwo[0] == null) && subcategFileTwo.length > 1) {
            this.props.import_set_data({
              errorNotSubCatTwo: true
            })
          }
          else {
            if (subcategFileTwo.length < 1) {
              this.props.import_set_data({
                errorNotSubCatTwo: false
              })
            }
            const foundCatTwo = subcategFileTwo.every(r => listItemsSubCatTwo.includes(r))

            if (!foundCatTwo) {
              this.props.import_set_data({
                errorSubCatTwo: true
              })
            }
            else {
              this.props.import_set_data({
                errorSubCatTwo: false
              })
            }

          }
        }

        if (categFileThree.length<1 && (listItemsSubCatThree[0] != null) && subcategFileThree.length > 1) {
          this.props.import_set_data({
            errorNotCatSubCatThree: true
          })
        }
        else {
          if ((listItemsSubCatThree[0] == null) && subcategFileThree.length > 1) {
            this.props.import_set_data({
              errorNotSubCatThree: true
            })
          }
          else {
            if (listItemsSubCatThree.length < 1) {
              this.props.import_set_data({
                errorNotSubCatThree: false
              })
            }
            const foundCatThree = listItemsSubCatThree.every(r => listItemsSubCatThree.includes(r))

            if (!foundCatThree) {
              this.props.import_set_data({
                errorSubCatThree: true
              })
            }
            else {
              this.props.import_set_data({
                errorSubCatThree: false
              })
            }

          }
        }

        if (categFileFour.length<1 && (listItemsSubCatFour[0] != null) && subcategFileFour.length > 1) {
          this.props.import_set_data({
            errorNotCatSubCatFour: true
          })
        }
        else {
          if ((listItemsSubCatFour[0] == null) && subcategFileFour.length > 1) {
            this.props.import_set_data({
              errorNotSubCatFour: true
            })
          }
          else {
            if (subcategFileFour.length < 1) {
              this.props.import_set_data({
                errorNotSubCatFour: false
              })
            }
            const foundCatFour = subcategFileFour.every(r => listItemsSubCatFour.includes(r))

            if (!foundCatFour) {
              this.props.import_set_data({
                errorSubCatFour: true
              })
            }
            else {
              this.props.import_set_data({
                errorSubCatFour: false
              })
            }

          }
        }

        if (categFileFive.length<1 && (listItemsSubCatFive[0] != null) && subcategFileFive.length > 1) {
          this.props.import_set_data({
            errorNotCatSubCatFive: true
          })
        }
        else {
          if ((listItemsSubCatFive[0] == null) && subcategFileFive.length > 1) {
            this.props.import_set_data({
              errorNotSubCatFive: true
            })
          }
          else {
            if (subcategFileFive.length < 1) {
              this.props.import_set_data({
                errorNotSubCatFive: false
              })
            }
            const foundCatFive = subcategFileFive.every(r => listItemsSubCatFive.includes(r))

            if (!foundCatFive) {
              this.props.import_set_data({
                errorSubCatFive: true
              })
            }
            else {
              this.props.import_set_data({
                errorSubCatFive: false
              })
            }

          }
        }
        this.props.import_current_tab(2)
        document.getElementById('file-doc').value = '';
        this.props.import_set_data({
          haveFile: true})

      }

    })
    
  }
  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        
        <form id="frmImportStep1" onSubmit={this.onSubmit_Step1}>
          <div className="field">
          
            <div className="notification is-info">
            {LanguageHelper.getLanguageString('ImportIndicators1.message')}
                </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label is-normal"><label className="label">{LanguageHelper.getLanguageString('ImportIndicators1.indicator')}</label></div>
            <div className="field-body">
              <div className="field">

                <div className="control">
                  
                  <span className="select">
                    <select onChange={this.onChange} id="selThematic"  name="selThematic" required="required" >
                      <option value="-1">{LanguageHelper.getLanguageString('ImportFile1.thematic')}</option>
                      {this.props.COptionTypeInformation}
                    </select>
                   
                    </span>
                   
                  


                </div>
                <br></br>
                <div className="control">
                  
                  <span className="select">
                    
                    <select onChange={this.onChange} id="selSubthematic" name="selSubthematic"  required="required" >
                      <option value="-1">{LanguageHelper.getLanguageString('ImportFile1.subthematic')}</option>
                      {this.COptionThematic()}
                    </select> 
                   
                    </span>
                   
                  


                </div>
                <br></br>
                <div className="control">
                  
                  <span className="select">
                   
                   
                    <select onChange={this.onChange} id="selTypeInformation" ref={this.selTypeInformation} name="selTypeInformation" required="required" >
                      <option value="-1">{LanguageHelper.getLanguageString('ImportIndicators1.indicator')}</option>
                      {this.COptionIndicators()}
                    </select>
                    </span>
                   
                  


                </div>
                <div className="field">
                 <a href= "https://ora.otca.org/wp-content/uploads/2021/template-ind/indicators_template.xlsx"  download target="_parent">{LanguageHelper.getLanguageString('ImportIndicators1.downlTemplate')}</a>
                </div>
                <div className="field">
                <a href="https://ora.otca.org/wp-content/uploads/2021/template-ind/catalogs.xlsx" target="_parent" download>{LanguageHelper.getLanguageString('ImportIndicators1.downlCatalog')}</a>
                  
                </div>
              </div>


            </div>

          </div>

          <hr />

          <hr />
          <div className="field is-horizontal">
            <div className="field-label is-normal"><label className="label">{LanguageHelper.getLanguageString('ImportIndicators1.selectFile')}</label></div>
            <div className="field-body">
              <div className="field">
                <div className="field file">
                  <label className="upload control">

                    <input onChange={this.onChange} id="file-doc" name="file-doc" type="file" />

                  </label>
                  
                </div>
                <p className="help">{LanguageHelper.getLanguageString('ImportIndicators1.maxSize')}</p>
                
              </div>
              
            </div>
          </div>
          {this.props.importData.haveFile?
                  <div >
                  <label id="errorFile" >{LanguageHelper.getLanguageString('ImportIndicators.messageLoadFile')}</label></div>:""}
          <hr />
          <div className="field is-horizontal">

            <div className="field-body">
              <div className="field">

                <div className="field">

                  <div className="field-body is-pulled-right">
                    <div className="field is-grouped">

                      <div className="control">
                        <button type="submit" disabled={!this.gotToStep2()} className="button is-primary">
                          <span>{LanguageHelper.getLanguageString('ImportIndicators1.submit')}</span>
                        </button>
                      </div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    currentTab: state.reducerTab.tab,
    collectTab: state.reducerTab.targets,
    importData: state.reducerData
    // currentTab: state.tab,
  }
}
export default connect(mapStateToProps, {
  import_current_tab,
  import_set_data,
  import_casa,
  import_setRecursos
})(ImportFileStep1)